export const WORD_LISTS: Record<string, { label: string; words: string[] }> = {
  everyday: {
    label: 'Everyday words',
    words: ['cat', 'dog', 'sun', 'hat', 'cup', 'bed', 'bus', 'pen', 'box', 'map', 'red', 'big', 'run', 'sit', 'hop', 'egg', 'leg', 'arm', 'top', 'van', 'fish', 'frog', 'ball', 'book', 'cake', 'door', 'game', 'hand', 'jump', 'kite', 'lamp', 'milk', 'nest', 'park', 'rain', 'ship', 'star', 'tree', 'walk', 'bird', 'boat', 'coat', 'duck', 'farm', 'goat', 'home', 'moon', 'shoe', 'sock', 'toy', 'wind', 'apple', 'bread', 'chair', 'clock', 'cloud', 'house', 'plant', 'sheep', 'smile', 'table', 'train', 'water'],
  },
  animals: {
    label: 'Animals',
    words: ['cat', 'dog', 'cow', 'pig', 'hen', 'fox', 'owl', 'bee', 'ant', 'bat', 'rat', 'duck', 'frog', 'fish', 'goat', 'bear', 'lion', 'deer', 'crab', 'seal', 'horse', 'sheep', 'mouse', 'tiger', 'zebra', 'snake', 'whale', 'camel'],
  },
  food: {
    label: 'Food',
    words: ['egg', 'jam', 'pie', 'tea', 'nut', 'bun', 'pea', 'fig', 'cake', 'rice', 'soup', 'milk', 'pear', 'plum', 'corn', 'bean', 'meat', 'fish', 'apple', 'bread', 'grape', 'lemon', 'melon', 'pasta', 'pizza', 'toast', 'honey'],
  },
  colours: {
    label: 'Colours',
    words: ['red', 'tan', 'blue', 'pink', 'gold', 'grey', 'navy', 'teal', 'lime', 'rose', 'green', 'white', 'black', 'brown', 'cream', 'lilac', 'peach', 'olive', 'amber', 'coral'],
  },
  home: {
    label: 'At home',
    words: ['bed', 'cup', 'mug', 'pan', 'pot', 'mat', 'rug', 'tap', 'bath', 'sofa', 'lamp', 'door', 'sink', 'oven', 'desk', 'fork', 'bowl', 'soap', 'chair', 'table', 'clock', 'spoon', 'plate', 'towel', 'shelf', 'stair'],
  },
  nature: {
    label: 'Nature',
    words: ['sun', 'sky', 'sea', 'mud', 'log', 'bud', 'ice', 'tree', 'leaf', 'rain', 'snow', 'wind', 'moon', 'star', 'rock', 'sand', 'pond', 'hill', 'seed', 'cloud', 'grass', 'river', 'stone', 'flower', 'beach', 'storm'],
  },
};

export function cleanWords(raw: string, max: number): string[] {
  const out = new Set<string>();
  for (const w of raw.split(/[\s,;]+/)) {
    const word = w.trim().toLowerCase();
    if (/^[a-z]{2,}$/.test(word) && word.length <= max) out.add(word);
  }
  return [...out];
}

const LETTER_POOL = 'eeeeeeeeeeaaaaaaaaaiiiiiiiiioooooooonnnnnnrrrrrrttttttllllssssuuuuddddgggbbccmmppffhhvvwwyykjxqz';

export function randomLetter(): string {
  return LETTER_POOL[Math.floor(Math.random() * LETTER_POOL.length)];
}

let dictionary: Promise<Set<string>> | null = null;

export function loadDictionary(): Promise<Set<string>> {
  if (!dictionary) {
    dictionary = fetch('/words/enable.txt')
      .then((r) => {
        if (!r.ok) throw new Error(String(r.status));
        return r.text();
      })
      .then((text) => new Set(text.split(/\r?\n/).map((w) => w.trim()).filter(Boolean)))
      .catch((e) => { dictionary = null; throw e; });
  }
  return dictionary;
}
